// TODO - REVIEW
export const TOTAL_PREMIUM_RECEIVED = {
  prefix: "$",
  value: 250353,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 0,
};
